var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _rect, _g13, _g14, _rect2, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundNoMatchBlueEon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1349,
    height: 700,
    fill: "none",
    viewBox: "0 0 1349 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_761_3526)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1349,
    height: 700,
    fill: "#286385",
    style: {
      fill: "#c73b24"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.58,
    y: 137.54,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62434
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(187.1 1331.8 207.59)",
    x: 1331.8,
    y: 207.59,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3865
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(33.97 726.53 542.74)",
    x: 726.53,
    y: 542.74,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.082909
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(115.1 1225.4 407.93)",
    x: 1225.4,
    y: 407.93,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14686
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(166.82 313.06 120.4)",
    x: 313.06,
    y: 120.4,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98247
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-12.677 318.2 270.99)",
    x: 318.2,
    y: 270.99,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.49599
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(218.54 1055.4 125.37)",
    x: 1055.4,
    y: 125.37,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87224
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(115.1 574.47 586.43)",
    x: 574.47,
    y: 586.43,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.20079
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-73.016 -10.394 473.7)",
    x: -10.394,
    y: 473.7,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44799
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-18.254 1004.6 298.08)",
    x: 1004.6,
    y: 298.08,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.022682
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-15.72 26.859 107.3)",
    x: 26.859,
    y: 107.3,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7347
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-8.1144 362.62 57.378)",
    x: 362.62,
    y: 57.378,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.054983
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-65.916 977.89 541.16)",
    x: 977.89,
    y: 541.16,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89616
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(108.51 135.57 392.4)",
    x: 135.57,
    y: 392.4,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 204.82,
    y: 405,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89616
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(108.51 228.81 659.86)",
    x: 228.81,
    y: 659.86,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89616
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(108.51 26.814 613.92)",
    x: 26.814,
    y: 613.92,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1208.8,
    y: 276,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89616
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(108.51 1232.8 530.86)",
    x: 1232.8,
    y: 530.86,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.61005
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-59.324 616.68 115.45)",
    x: 616.68,
    y: 115.45,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2309
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(120.17 569.97 638.9)",
    x: 569.97,
    y: 638.9,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-33.465 400.93 563.75)",
    x: 400.93,
    y: 563.75,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9032
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(233.75 1080 681.4)",
    x: 1080,
    y: 681.4,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58287
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(214.48 871.51 31.896)",
    x: 871.51,
    y: 31.896,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21164
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(60.844 584.59 353.96)",
    x: 584.59,
    y: 353.96,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.075987
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(228.17 1241.4 359)",
    x: 1241.4,
    y: 359,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89616
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(108.51 1351.8 629.92)",
    x: 1351.8,
    y: 629.92,
    width: 23.844,
    height: 29.806,
    fill: "#FAFAFA",
    fillOpacity: 0.07
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_761_3526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1349,
    height: 700,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundNoMatchBlueEon);
export default __webpack_public_path__ + "static/media/background_noMatch_blueEON.410dc27fde3ac7368dcefa9f64281728.svg";
export { ForwardRef as ReactComponent };